import { render, staticRenderFns } from "./learnerChildList_learner.vue?vue&type=template&id=0dd3fcbf&"
import script from "./learnerChildList_learner.vue?vue&type=script&lang=js&"
export * from "./learnerChildList_learner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports